<div class="numbers-table">
  <table>
    <thead>
      <tr>
        <td translate>numbers.table.thead.number.label</td>
        <td translate>numbers.table.thead.status.label</td>
        <td translate>numbers.table.thead.company-id.label</td>
        <td translate>numbers.table.thead.type.label</td>
        <td translate>numbers.table.thead.class.label</td>
        <td translate>numbers.table.thead.provider.label</td>
        <td translate>numbers.table.thead.creation.label</td>
        <td translate>numbers.table.thead.actions.label</td>
      </tr>
    </thead>
    <tbody *ngIf="!loading">
      <tr *ngFor="let did of dids">
        <td class="numbers-table__number">
          <span [title]="did.country" class="flag-icon flag-icon-{{(did.country || 'unknown') | lowercase}}"></span>
          {{did.number}}
        </td>
        <td>
          <gdp-did-status [status]="did.status"></gdp-did-status>
        </td>
        <td>
          <a [routerLink]="['/dashboard/companies/',did.company_id]">{{did.company_id}}</a>
        </td>
        <td>
          <div class="types">
            <div class="types__type">
              <gdp-number-type [type]="did.did_type"></gdp-number-type>
            </div>
            <div class="types__temporary">
              <gdp-number-temporary-status [temporaryStatus]="did.is_from_pool"></gdp-number-temporary-status>
            </div>
          </div>
        </td>
        <td>
          {{did.did_class}}
        </td>
        <td>
          {{did.provider}}
        </td>
        <td>
          <div class="dates">
            <span [ngbTooltip]="did.creation_date | date:'medium': undefined: locale">
              {{did.creation_date | date: 'dd.MM.yyyy'}}
              <i class="icon-small-info"></i>
            </span>
            <i class="dates__separator">/</i>
            <span [ngbTooltip]="did.allocation_date | date:'medium': undefined: locale">
              {{did.allocation_date | date: 'dd.MM.yyyy'}}
              <i class="icon-small-info"></i>
            </span>
          </div>
        </td>
        <td class="numbers-table__actions">
          <button class="vox-btn btn-warning" type="button" (click)="openFullInfoPopup(did)"
            [ngbTooltip]="'numbers.table.tbody.actions.full-info.tooltip' | translate">
            <i class="icon-small-info"></i>
          </button>
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="loading">
      <tr *ngFor="let i of loadingLinesArray">
        <td colspan="8">
          <ngx-skeleton-loader></ngx-skeleton-loader>
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="!loading && dids.length === 0">
      <tr>
        <td colspan="8" translate>numbers.empty</td>
      </tr>
    </tbody>
  </table>
</div>
